

<div class="p-2 busy-overlay-parent" [ngClass]="isLoading?'disabled':''">

    <div *ngIf="isLoading" class="font-weight-bold busy-overlay">
      <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
    </div>

    <div *ngIf="errorMsg" class="alert alert-danger d-flex flex-row justify-content-between">
        {{errorMsg}}
        <div role="button" (click)="errorMsg=''"><i class="fa fa-times"></i></div>
    </div>

    <table class="table table-striped table-bordered table-sm">
        <tr><th colspan=2 class="text-center"><h3>Point {{pointId}}</h3></th></tr>
        <tr *ngFor="let field of $any(point) | keyvalue">
            <th class="text-nowrap">{{(field.key | underscore).split('_').join(' ') | ucwords}}</th>            
            <ng-container [ngSwitch]="field.key">
                <td *ngSwitchCase="'updatedAt'">
                    {{point[$any(field).key]|date:'yyyy-MM-dd HH:mm:ss.SSS'}} ({{point[$any(field).key]}})
                </td>
                <td *ngSwitchDefault>
                    {{point[$any(field).key]}}
                </td>
            </ng-container>
        </tr>
    </table>

    <div class="alert alert-info" *ngIf="!point&&!isLoading">Point '{{pointId}}' not found.</div>

    <a href="javascript:false;" (click)="loadPoint()"><i class="fa fa-refresh"></i>&nbsp;Refresh</a>
</div>
